import { TenantProfile } from './tenantProfile';
export interface CreateTenantInput {
  id: number;
  name: string;
  isActive: boolean;
  userName: string;
  userSurname: string;
  userEmail: string;
  userPhone: string;
  tenantProfile: TenantProfile;
  tenantProfileId?: number;
}

export const InitialTenant: CreateTenantInput = {
  id: 0,
  name: '',
  isActive: true,
  userName: '',
  userSurname: '',
  userEmail: '',
  userPhone: '',
  tenantProfile: {
    id: 0,
    tenantId: 0,
    address: '',
    city: '',
    zipCode: '',
    companyEmail: '',
    companyPhone: '',
    latitude: undefined,
    longitude: undefined,
    website: undefined,
    vat: undefined,
    labourRate: undefined,
    onlineBooking: false,
    tenantProfileWorkStations: [],
    managers: [],
  },
};
